import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { getHybridAndCompleteData, searchInventoryLedger } from "./InventoryLedger.action";
import { setHeading } from "../../../accounts/account.actions";
import { Link, Navigate } from "react-router-dom";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import Select from "react-select";
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import moment from "moment";


const InventoryLedger = (props) => {
  const [startDate, setStartDate] = useState(moment().subtract(1, 'month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [item, setItem] = useState("");


  function searchData() {
    props.searchInventoryLedgerList(
      {
        startDate: !isEmpty(startDate) ? startDate : "",
        endDate: !isEmpty(endDate) ? endDate : "",
        productId: item,
      },
      startDate,
      endDate
    );
    return <Navigate to="/inventory/Ledger-List" />;
  }

  const getHybridAndCompleteData = props.hybridAndCompleteData.map((x) => {
    let data = { value: x._id, label: x.name };
    return data;
  });
  const handleChangeLevel5Ledger = (selectedOption) => {
    setItem(selectedOption.value);
  };

  useEffect(() => {
    props.getHybridAndCompleteData();
    props.setHeading("Inventory Ledger");
  }, []);

  return (
    <>
      {props.isFetchingHybridAndCompleteData ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Start Date *</b> </Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>End Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Product *</b></Form.Label>
                <Select
                  placeholder="Select Product"
                  onChange={handleChangeLevel5Ledger}
                  options={getHybridAndCompleteData}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {isEmpty(item) ? (
              <Button variant="contained" endIcon={<SearchIcon />} size="large" disabled> SEARCH LEDGER </Button>
            ) : (
              <Link to={{ pathname: "/inventory/Ledger-List", state: { start: startDate, end: endDate } }}>
                <Button variant="contained" endIcon={<SearchIcon />} size="large" onClick={(e) => searchData()}> SEARCH LEDGER </Button>
              </Link>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getHybridAndCompleteData: () => dispatch(getHybridAndCompleteData()),
    searchInventoryLedgerList: (data, startDate, endDate) => dispatch(searchInventoryLedger(data, startDate, endDate)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  hybridAndCompleteData: state.InventoryLegderReducer.hybridAndCompleteData,
  isFetchingHybridAndCompleteData: state.InventoryLegderReducer.isFetchingHybridAndCompleteData,
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryLedger);
